// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2c99cad0","977":"fec26fb8"}[chunkId] + ".chunk.js";
};